import { LoginBonus } from '../../../../services/exports/Interfaces';
import useGetHandlerByKind from './useGetHandlerByKind';

const useLoginBonusHandler = () => {
  const getHandlerByKind = useGetHandlerByKind();
  const handle = (bonus: LoginBonus) => {
    if (!bonus) {
      return;
    }

    const handler = getHandlerByKind(bonus.kind);

    handler && handler(bonus);
  };

  return handle;
};

export default useLoginBonusHandler;
